import { Navigate } from 'react-router-dom'
import { useIsInsightsAdmin } from './hooks/useIsInsightsAdmin'
import { INSIGHT_TAB_ROUTE } from './utils/insightInbox.utils'

export const InsightsAdminRoute = ({ children }: { children: JSX.Element }) =>
  useIsInsightsAdmin() ? children : <Navigate replace to={INSIGHT_TAB_ROUTE.new} />
